import React from 'react';
import { Leaf, Zap } from 'lucide-react';
export function CropFarming() {
  return <section id="crops" className="py-20 bg-stone-100" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="text-center mb-16" data-id="element-77">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4" data-id="element-78">
            Sustainable Crop Farming
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-79">
            Our integrated farming approach ensures that our crops support our
            dairy operations and vice versa, creating a sustainable cycle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-80">
          {/* Maize Silage */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg group hover:shadow-xl transition-all duration-300" data-id="element-81">
            <div className="h-64 overflow-hidden relative" data-id="element-82">
              <div className="absolute top-4 left-4 bg-amber-500 text-white px-3 py-1 rounded-full text-sm font-bold z-10 flex items-center" data-id="element-83">
                <Leaf className="h-4 w-4 mr-1" data-id="element-84" /> Fodder
              </div>
              <img src="https://images.unsplash.com/photo-1622383563227-0440114a8790?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80" alt="Maize field" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-85" />
            </div>
            <div className="p-8" data-id="element-86">
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-87">
                Maize Silage
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6" data-id="element-88">
                We cultivate high-quality maize specifically for silage
                production. This ensures our herd has access to nutritious,
                high-energy fodder year-round, regardless of the season. The
                fertile soil of our farm produces exceptional yields.
              </p>
              <ul className="space-y-2 text-sm text-gray-500" data-id="element-89">
                <li className="flex items-center" data-id="element-90">
                  • High starch content for energy
                </li>
                <li className="flex items-center" data-id="element-91">
                  • Preserved for year-round feeding
                </li>
                <li className="flex items-center" data-id="element-92">
                  • Grown using organic manure
                </li>
              </ul>
            </div>
          </div>

          {/* Biogas */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg group hover:shadow-xl transition-all duration-300" data-id="element-93">
            <div className="h-64 overflow-hidden relative" data-id="element-94">
              <div className="absolute top-4 left-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-bold z-10 flex items-center" data-id="element-95">
                <Zap className="h-4 w-4 mr-1" data-id="element-96" /> Energy
              </div>
              <img src="https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80" alt="Biogas plant concept" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-97" />
            </div>
            <div className="p-8" data-id="element-98">
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-99">
                Biogas Production
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6" data-id="element-100">
                Sustainability is at our core. We utilize farm waste to produce
                biogas, providing clean energy for our farm operations. The
                byproduct, bio-slurry, is returned to the fields as a potent
                organic fertilizer.
              </p>
              <ul className="space-y-2 text-sm text-gray-500" data-id="element-101">
                <li className="flex items-center" data-id="element-102">• Renewable energy source</li>
                <li className="flex items-center" data-id="element-103">
                  • Reduces carbon footprint
                </li>
                <li className="flex items-center" data-id="element-104">
                  • Produces organic fertilizer
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}